import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MailboxConnectionResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

const MAILBOX_CONNECTIONS_KEY = ['mailbox-connections'];

export function useMailboxConnectionsQuery() {
  return useQuery({ queryKey: MAILBOX_CONNECTIONS_KEY, queryFn: () => api.get<MailboxConnectionResponse[]>('/mailbox-connections') });
}

export function useDisconnectMailbox() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/mailbox-connections/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MAILBOX_CONNECTIONS_KEY }),
  });
}

/** `start*` are full-page OAuth redirects, not API calls — a plain
 * navigation, same reasoning the Google/Microsoft consent screen can't be
 * shown inside a fetch response. */
export function mailboxConnectUrl(provider: 'google' | 'microsoft'): string {
  return `/api/v1/mailbox-connections/${provider}/start`;
}
